export default __webpack_public_path__ + "static/media/mem.3b92025f.svg";